import { AuthState } from 'core/types/redux/AuthState';
import { AuthActions } from 'core/types/redux/authActions';
import { AUTH } from 'core/datasets/action';
import { jwtDecode } from 'jwt-decode';
import { isString } from 'lodash';
import { AppState } from 'core/redux/rootReducer';

export const initState: AuthState = {
    user: '',
    token: '',
    refresh_token: '',
    isLoggedIn: false,
    expiresAt: 0,
};

export const authReducer = (state = initState, action: AuthActions): AuthState => {
    switch (action.type) {
        case AUTH.TOKEN_CHANGED: {
            return {
                ...state,
                token: action.payload,
            };
        }
        case AUTH.REFRESH_TOKEN_CHANGED: {
            return {
                ...state,
                refresh_token: action.payload,
            };
        }
        case AUTH.LOGIN_SUCCESS: {
            const decoded = jwtDecode(action.payload.token);

            if (!decoded.exp) {
                console.error('JWT Token is invalid or expired');
                return state;
            }

            return {
                ...state,
                user: action.payload.user,
                token: action.payload.token,
                refresh_token: action.payload.refresh_token,
                isLoggedIn: true,
                expiresAt: decoded?.exp || 0,
            };
        }
        case AUTH.LOGOUT:
            return {
                ...state,
                user: '',
                token: '',
                refresh_token: '',
                isLoggedIn: false,
                expiresAt: 0,
            };
        case AUTH.EXPIRED_TOKEN_REFRESHED: {
            return {
                ...state,
                token: action.payload,
            };
        }
        case AUTH.TOKENS_CHANGED: {
            if (!isString(action.payload.token)) {
                console.error('AUTH.TOKENS_CHANGED payload token is not a string', { action });
                return state;
            }

            const decoded = jwtDecode(action.payload.token);

            if (!decoded.exp) {
                console.error('JWT Token is invalid or expired');
                return state;
            }

            return {
                ...state,
                token: action.payload.token,
                refresh_token: action.payload.refresh_token,
                expiresAt: decoded?.exp || 0,
            };
        }
        default:
            return state;
    }
};

const authSelector = (state: AppState) => state.auth;
const token = (state: AppState) => authSelector(state).token;
const user = (state: AppState) => authSelector(state).user;

export const authSelectors = { token, user };
